import { Head } from "@inertiajs/react"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { AlertCircle } from "lucide-react"

export default function InvitationExpired() {
  return (
    <>
      <Head title="Invitación Expirada" />

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-teal-50 to-slate-50 p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="bg-destructive/10 flex h-16 w-16 items-center justify-center rounded-full">
                <AlertCircle className="text-destructive h-8 w-8" />
              </div>
            </div>
            <CardTitle className="text-2xl">Invitación Expirada</CardTitle>
            <CardDescription>
              Esta invitación ha expirado y ya no es válida.
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-4 text-center">
            <p className="text-muted-foreground text-sm">
              Las invitaciones expiran después de 7 días por razones de
              seguridad. Por favor, contacta a la persona que te invitó para
              solicitar una nueva invitación.
            </p>

            <Button asChild className="w-full">
              <a href="/sign_in">Ir a inicio de sesión</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
